module.exports = __webpack_public_path__ + "img/blacktie-rotated.9a0f746.webp";